export default __webpack_public_path__ + "assets/partly-cloudy-night-sleet.9a9df5ac.svg";